import { styled } from '@mui/material';

export const PopupStyled = styled('div')`
  background: #fff;
  height: 90%;
  width: 90%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 111;
  right: 0;
  bottom: 0;
  margin: auto;
  border-radius: 8px;

  .close {
    position: absolute;
    float: none;
    z-index: 3;
    top: -15px;
    right: -15px;
    padding: 0;
    opacity: 1;
    font-size: 14px;
    cursor: pointer;
    background: #fff;
    border-radius: 50%;
    height: 30px;
    width: 30px;
    line-height: 38px;
    text-align: center;

    &:hover {
      svg,
      i {
        color: #ea475c;
      }
    }

    svg,
    i {
      color: #aaa;
      font-size: 20px;
      transition: all 0.3s ease;
    }
  }

  h2 {
    font-size: 1.4em;
    padding: 20px 0;
    text-align: center;
  }

  .square-button {
    margin-top: 20px;
    text-align: center;
  }

  input {
    border-bottom: 1px solid #ccc;
  }

  iframe {
    height: 100% !important;
    width: 100% !important;
    position: relative;
    top: 0;
    left: 0;
    border-radius: 8px;
  }

  &.rtl {
    text-align: right;

    input {
      text-align: right;
    }
  }

  max-height: 550px;
  max-width: 600px;

  .contact-popup-content {
    overflow-y: auto;
    height: 100%;
    padding: 30px;
  }

  @media screen and (max-width: 768px) {
    max-height: 100vh;
    height: 92%;
  }

  @media screen and (max-width: 768px) and (orientation: landscape) {
    overflow-y: auto;
    overflow-x: hidden;

    .close {
      top: 0;
      right: 0;
    }
  }

  .appointment-block label {
    font-size: 12px;
  }

  h2 {
    text-align: left;
    font-weight: normal;
    font-style: normal;
    padding: 0;
    font-size: 18px;
    margin-top: -10px;
    margin-bottom: 30px;
  }

  .input-c {
    width: 49%;
    margin-bottom: 10px;

    &.full {
      width: 100%;
    }

    label {
      font-weight: normal;
    }

    input,
    textarea {
      border: 1px solid #eee;
    }

    textarea {
      height: 100px;
    }
  }

  .left {
    float: left;
  }

  .right {
    float: right;
  }

  .square-button {
    background: #ea475c;
    color: #fff;
    width: 120px;
    float: right;
    margin-top: 0;
    padding: 12px;
    cursor: pointer;
  }

  .agent-cards {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 20px;

    .agent-card {
      flex-basis: 50%;
      @media screen and (max-width: 768px) {
        width: 100% !important;
        flex-basis: 100%;
      }

      &:first-child {
        margin-left: 0;
      }

      .img {
        background-size: cover;
        background-repeat: no-repeat;
        height: 60px;
        width: 60px;
        border-radius: 50%;
        background-position: center;
        display: inline-block;
        vertical-align: middle;
      }

      .text {
        display: inline-block;
        margin-left: 10px;
        vertical-align: middle;
        width: calc(100% - 70px);

        h4 {
          font-size: 16px;
          margin-bottom: 2px;
          text-overflow: ellipsis;
          overflow: hidden;
          width: 100%;
          white-space: nowrap;
        }

        a {
          color: #ea475c;
        }
      }
    }
  }
`;

const InputStyle = {
  fontSize: '1em',
  padding: '8px',
  width: '100%',
  height: '40px',
  margin: 0,
  textIndent: '8px',
  display: 'block',
  fontFamily: 'Roboto',
  border: '1px solid #eee',
  outline: 'none',
  fontWeight: 300
};

export const InputStyled = styled('input')({ ...InputStyle });

export const TextAreaStyled = styled('textarea')({ ...InputStyle, resize: 'none' });
